'use client';

import { useEffect, useRef } from 'react';
import { useClickStream, EventType } from '@brahma/hooks';
import { usePathname } from 'next/navigation';
import useGlobalContext from '$ops-portal/hooks/use-global-context';
export default function PageVisitDataCapture() {
  const {
    state
  } = useGlobalContext();
  const {
    trackEvent
  } = useClickStream('PageVisitDataCapture', state.user);
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  useEffect(() => {
    if (pathname !== lastPathname.current) {
      trackEvent({
        eventType: EventType.PAGE_VISIT,
        data: {}
      });
      lastPathname.current = pathname;
    }
  }, [pathname, trackEvent]);
  return null;
}